import { Center, Loader } from '@mantine/core'
import { AppPage } from '@markku/components'
import { createFileRoute } from '@tanstack/react-router'
import { visitHooks } from '../../lib/trpcHooks'
import { propertyHooks } from '../../lib/trpcHooks/propertyHooks'
import { PastVisit } from '../../modules/visit/PastVisit'
import { FutureVisit } from '../../modules/visit/FutureVisit'

function VisitDetailPage() {
  const { id } = Route.useParams()
  const visitId = Number(id)

  const { data: visit, isLoading: isLoadingVisit } =
    visitHooks.useGetById(visitId)
  const { data: property, isLoading: isLoadingProperty } =
    propertyHooks.useGetById(visit?.propertyId ?? 0, {
      enabled: !!visit?.propertyId,
    })

  const isLoading = isLoadingVisit || isLoadingProperty

  if (isLoading) {
    return (
      <AppPage title="Käynti" backTarget="/visits">
        <Center py="xl">
          <Loader size="md" />
        </Center>
      </AppPage>
    )
  }

  if (!visit) {
    return (
      <AppPage title="Käyntiä ei löytynyt" backTarget="/visits">
        <Center py="xl">Käyntiä ei löytynyt</Center>
      </AppPage>
    )
  }

  // Check if visit is in the past
  const isPastVisit = new Date(visit.startTime) < new Date()

  return (
    <AppPage
      title={isPastVisit ? 'Mennyt käynti' : 'Tuleva käynti'}
      backTarget="/visits"
    >
      {isPastVisit ? (
        <PastVisit visit={visit} property={property} />
      ) : (
        <FutureVisit visit={visit} />
      )}
    </AppPage>
  )
}

export const Route = createFileRoute('/_app/visit/$id')({
  component: VisitDetailPage,
})
